export enum PublicApiPaymentType {
  WITHDRAWAL = 'WITHDRAWAL',
  EXCHANGE = 'EXCHANGE',
  DEPOSIT = 'DEPOSIT',
  ACCOUNT_TRANSFER = 'ACCOUNT_TRANSFER'
}
